import React from 'react'
import { linkActions } from '../../utils/common'

const HocButton = ({ children, button, btnAction }) => {
  let btnClass = ''
  let label = ''

  if (children?.props?.className) {
    btnClass = children.props.className
  }
  if (typeof children?.props?.children === "string") {
    label = children.props.children
  }

  if (button.action === linkActions.CLICK) {
    return (
      <div className={`${btnClass}`} onClick={() => btnAction()}>
        {label || button?.label}
      </div>
    )
  }
  return children
}

export default HocButton
